import { render, staticRenderFns } from "./BannerTest1.vue?vue&type=template&id=38575967&scoped=true&"
import script from "./BannerTest1.vue?vue&type=script&lang=js&"
export * from "./BannerTest1.vue?vue&type=script&lang=js&"
import style0 from "./BannerTest1.vue?vue&type=style&index=0&id=38575967&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38575967",
  null
  
)

export default component.exports